<template>
    <div class="w-full ml-auto mr-auto max-w-[1920px] relative">
        <CoverWidget v-if="organization"></CoverWidget>

        <div
            v-if="showCompleteProfileInfoBox"
            class="p-8 lg:rounded bg-[#556EE6] xxs:mt-4 lg:mt-6 flex justify-between xxs:flex-col lg:flex-row xxs:items-start lg:items-top"
        >
            <div class="flex xxs:flex-col lg:flex-row lg:items-center">
                <ItemsList color="#556EE6"/>
                <div class="flex flex-col items-left xxs:ml-0 lg:ml-8 xxs:mt-4">
                    <p class="text-white text-body-5 font-medium">Complete your profile</p>
                    <p class="text-slate-200 text-body-6 mt-2">
                        Enhance your connectivity and access by filling in your information
                    </p>
                </div>
            </div>
            <div class="flex items-center xxs:mt-6">
                <CoreButton
                    button-type="ghost"
                    class="ml-auto text-[#556EE6]"
                    @click="router.push('profile')"
                >Complete Profile
                </CoreButton>
            </div>
        </div>
        <div class="w-full mt-4">
            <div
                v-for="row in widgets"
                :key="row"
                :class="row.length > 1 && 'grid xxs:grid-cols-1 mlg:grid-cols-2 mlg:grid-cols-3 gap-2'"
                class="mb-4"
            >
                <component v-for="widget in row" :key="widget.i" :is="widget.widget" v-bind="widget.layout" :class="widget.w"/>
            </div>
        </div>

        <div class="flex flex-col lg:flex-row gap-6 mt-6">
            <!--  <div class="flex flex-col lg:flex-row gap-6 mt-6">-->
            <!--    <div class="flex flex-col gap-6 lg:w-1/3">-->
            <!--      <EventSection :color="color" />-->
            <!--      <DocumentsSection class="md:flex-grow" :color="color" />-->
            <!--    </div>-->
            <!--    <BlogSection class="md:flex-grow lg:w-2/3" :color="color" />-->
            <!--  </div>-->
            <!--        <ResourcesSection class="md:flex-grow" color="#000000" />-->
            <!--        <InboxWidget :color="color"/>-->
        </div>
    </div>
</template>
<script setup>
import {useAuth} from "@/stores/AuthStore";
import InboxWidget from "@/components/widgets/InboxWidget.vue";
import ChatNotifications from "@/components/custom-cometchat/ChatNotifications.vue";
import NewsWidget from "@/components/widgets/NewsWidget.vue";
import CoreButton from "@/components/core/Button.vue";
import {useRouter} from "vue-router";
import ItemsList from "@/components/icons/ItemsList.vue";
import ResourcesWidget from "@/components/widgets/ResourcesWidget.vue";
import CoverWidget from "@/components/custom/DashboardCover.vue";
import {storeToRefs} from "pinia";
import {computed, markRaw, onBeforeMount, onMounted, ref} from "vue";
import {cloneDeep} from "lodash";
import {useCheckFeature} from "@/composables/useCheckFeature";

const {organization, showCompleteProfileInfoBox} = useAuth();
const {loadMemberFeatures, memberFeatures} = useCheckFeature();
const {member} = storeToRefs(useAuth());

const router = useRouter();

const widgets = ref([]);

const isChatFeatureActive = computed(() => {
    if(!memberFeatures.value) {
        return false;
    }

    return memberFeatures.value.chat;
});

onBeforeMount(() => {
    loadMemberFeatures(organization.value.slug);
})

onMounted(() => {
    let aux = cloneDeep(member.value.dashboard_widgets);
    if(!isChatFeatureActive.value) {
        aux = aux.filter(widget => widget.widget !== 'ChatNotifications');
    }

    // Step 1: Group elements by rows
    const groupedByRow = aux.reduce((acc, widget) => {
        const rowIndex = widget.y / 30;
        if (!acc[rowIndex]) {
            acc[rowIndex] = [];
        }

        switch (widget.widget) {
        case 'Inbox':
            widget.widget = markRaw(InboxWidget);
            break;
        case 'News':
            widget.widget = markRaw(NewsWidget);
            break;
        case 'Resources':
            widget.widget = markRaw(ResourcesWidget);
            break;
        case 'ChatNotifications':
            widget.widget = markRaw(ChatNotifications);
            widget.layout = {layout: 'dashboard'};
            break;
        }

        widget.w = `col-span-${widget.w}`;

        acc[rowIndex].push(widget);
        return acc;
    }, {});

    // Step 2: Sort each row by the x value in ascending order
    widgets.value = Object.keys(groupedByRow).map(key => {
        return groupedByRow[key].sort((a, b) => a.x - b.x);
    });
});
</script>
